import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-call-queue',
  templateUrl: './call-queue.component.html',
  styleUrls: ['./call-queue.component.css']
})
export class CallQueueComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
